import { Card, Row, Col, Image, Spin, Modal, message, Button, Table, Alert, Steps, Typography } from "antd";
import logo from "../../assets/images/NewLogoCW.svg";
import red from "../../assets/images/red.svg";
import green from "../../assets/images/green.svg";
import posImg from "../../assets/images/posImg.svg";
import db, { isDbBridgeAvailable } from "../../database";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import { timeStamp } from "../../utils/timestamp";
import { useEffect, useState, useRef } from "react";
import { LoadingOutlined, MedicineBoxOutlined, CheckCircleOutlined, CloseCircleOutlined, SyncOutlined, LogoutOutlined } from "@ant-design/icons";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import { useHistory } from "react-router-dom";
import { cartHistory, getTills, posConfigService, syncTillData, upsertPOSActivity } from "../../services";
import { useTranslation } from "react-i18next";
import { getMultilingualText } from "../../utils/getMultilingualText";
import laptop3 from "../../assets/images/laptop3.svg";
import Scrollbars from "react-custom-scrollbars";
import { getStoreOps, upsertStoreOps, tillRegistration, unlinkTill } from "../../services";
import SyncSide from "../../assets/images/sideFullSync.svg";
import messages from "../../errors/messages.en-IN.json";
import PostCloseSalesModal from "./PostCloseSalesModal";
import useAuthStore from "../../stores/useAuthStore";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import useCartStore from "../../stores/useCartStore";
import useSessionStore from "../../stores/useSessionStore";
import useTransactionStore from "../../stores/useTransactionStore";
import useRestaurantStore from "../../stores/useRestaurantStore";
import useReferenceStore from "../../stores/useReferenceStore";
import { trace } from "../../utils/debugTrace";
import { posTillUser } from "../../utils/posSession";
import { getTillBusinessDate, isPastBusinessDay } from "../../utils/tillBusinessDate";
import { getLocalMaxSequence, resolveInitialDocumentSequence } from "../../utils/documentSequenceUtils";
import { logSequenceEvent } from "../../utils/sequenceAudit";
import { getTillMode, getTillModeRoute, pickDefaultRoute, parseTillAccess, sessionOwnerMatchesCurrentUser, TILL_MODES } from "../../constants/accessControl";
import {
  classifyTillHold,
  describeTillHolder,
  getPosDeviceId,
  isEstimateOnlyTill,
  isTillMoveSupported,
  POS_DEVICE_ID_KEY,
  registerTillWithUseHere,
  reholdTillIfFree,
} from "../../utils/tillDeviceRegistration";
import { currentLinkedTill, readTillSwitchBlock, shouldKeepLinkedTill, tillSwitchBlockMessage } from "../../utils/tillResumeFallback";
import {
  clearCloseTillFromTillScreen,
  markCloseTillFromTillScreen,
  MOVED_MESSAGE,
  OFFLINE_MESSAGE,
  OTHER_USER_MESSAGE,
  readCloseTillBlockers,
  readServerParkedBills,
  readServerTillList,
  readTillLogoutContext,
  signOutFromTillScreen,
  TILL_LOGOUT_STATE,
  unsentBillsMessage,
} from "../../utils/tillScreenLogout";
import "./TillScreens.css";

const Till = () => {
  const { t } = useTranslation();
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  const redirectUrl = process.env.REACT_APP_redirectURL;
  const [runEffect, setRunEffect] = useState(true);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [tills, setTills] = useState();
  const [tillLoadError, setTillLoadError] = useState(null);
  const [tillValue, setTillValue] = useState(() => {
    // Clear stale tillValue on entry so a previous selection doesn't persist
    const stored = useAuthStore.getState().tillValue;
    return stored || {};
  });
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorProducts, setErrorProducts] = useState([]);
  const [postCloseModalVisible, setPostCloseModalVisible] = useState(false);
  const [postCloseData, setPostCloseData] = useState({
    storeClosedDate: "",
    newBusinessDate: "",
    closedTime: "",
    tillId: "",
    cashierName: "",
  });
  const retryCountRef = useRef(0);
  const MAX_RETRIES = 3;
  const REGISTRATION_STEPS = ["Syncing Till Data", "Loading POS Config", "Checking Store", "Registering Till", "Navigating"];
  const [registrationStep, setRegistrationStep] = useState(-1);
  const [registrationError, setRegistrationError] = useState(null);
  const [lastRegistrationArgs, setLastRegistrationArgs] = useState(null);
  const [resumeSetupVisible, setResumeSetupVisible] = useState(false);
  // BUG-2368: the linked till is kept on screen after a failed tillData read.
  const [keptLinkedTill, setKeptLinkedTill] = useState(false);
  const previousTillValueRef = useRef(null);
  // TSK-5406: header Logout — what the click found (null = popup closed) and the check in flight.
  const [logoutDialog, setLogoutDialog] = useState(null);
  const [logoutChecking, setLogoutChecking] = useState(false);
  // TSK-5406: back on this screen, a Close Till started from it is over (Back or a finished close).
  useEffect(() => {
    clearCloseTillFromTillScreen();
  }, []);
  const islocked = useSessionStore.getState().locked;
  let email = "";
  let Enterprise = "";
  let username;
  let cleanToken;
  const authHeaders = getOAuthHeaders();
  if (authHeaders && authHeaders.access_token && (authHeaders.email || authHeaders.username)) {
    email = authHeaders.email;
    Enterprise = authHeaders.Enterprise;
    cleanToken = authHeaders.access_token;
    username = authHeaders.username;
  } else {
    console.warn("[AUTH-DIAG] Till → redirecting to /sign-in (no valid auth)");
    history.push("/sign-in");
  }

  const handleStoreOpsService = async (bunitId) => {
    const posConfig = usePOSConfigStore.getState().posConfig;
    const tillData = useAuthStore.getState().tillData;
    const dayEndPreferences = JSON.parse(tillData?.dayEndPreferences || "[]");
    trace("Till", "handleStoreOpsService", {
      bunitId,
      disableOffline: posConfig?.disableOfflineBilling,
      tillAccessType: Array.isArray(tillData?.tillAccess) ? "ARRAY" : typeof tillData?.tillAccess,
      hasCsBunit: !!tillData?.tillAccess?.csBunit,
    });
    if (posConfig?.disableOfflineBilling === "Y" && dayEndPreferences[0]?.postCloseSalesDate === "NXT") {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();
      trace("Till", "storeOps(NXT) openEvents", { count: tillEvents.length, date: tillEvents[0]?.openingTime?.split(" ")[0], businessDate: getTillBusinessDate(tillEvents[0]) });
      if (tillEvents.length > 0) {
        const currentDate = dayjs().format("YYYY-MM-DD");
        // BUG-2171: compare the business date, not the opening date — a till opened
        // last evening for today is not a day change.
        const tillEventDate = getTillBusinessDate(tillEvents[0]);
        if (!isPastBusinessDay(tillEvents[0])) {
          return await getStoreOps(bunitId);
        } else if (posConfig?.enableAutoStoreClose !== "Y") {
          trace("Till", "day change (NXT) but auto close disabled — continuing billing", { currentDate, tillEventDate });
          return await getStoreOps(bunitId);
        } else {
          trace("Till", "day change detected (NXT) → /close-till", { currentDate, tillEventDate });
          const activeTillSession = useSessionStore.getState().tillSession;
          if (!activeTillSession) {
            trace("Till", "day change (NXT): no tillSession — orphaned open events, closing silently");
            await db.tillEvents.where("tillStatus").equals("open").modify({ tillStatus: "closed", isSynced: 1 });
            return await getStoreOps(bunitId);
          }
          setLoading(false);
          history.push("/close-till");
          return { redirected: true };
        }
      } else {
        const response = await getStoreOps(bunitId);
        if (response?.status === 200) {
          const storeOpsData = response?.data?.data?.getStoreOps;
          if (storeOpsData?.status === "OP") {
            return response;
          } else if (storeOpsData?.status === "CL") {
            const tillData = useAuthStore.getState().tillData;
            const tillValue = useAuthStore.getState().tillValue;

            // Calculate dates
            // BUG-2171: the store-ops fields are date / closeTime (CWRStoreDailyOps) —
            // businessDate / closedTime never existed, so the popup always showed today
            // and "8:00 PM".
            const closedDate = dayjs(storeOpsData?.date || new Date()).format("DD/MM/YYYY");
            const nextBusinessDate = dayjs(storeOpsData?.date || new Date())
              .add(1, "days")
              .format("DD/MM/YYYY");
            const closedTime = storeOpsData?.closeTime && dayjs(storeOpsData.closeTime).isValid() ? dayjs(storeOpsData.closeTime).format("h:mm A") : "8:00 PM";

            setPostCloseData({
              storeClosedDate: closedDate,
              newBusinessDate: nextBusinessDate,
              closedTime: closedTime,
              tillId: tillValue?.name || tillData?.tillAccess?.cwrTill?.till || "N/A",
              cashierName: username || "N/A",
            });
            setPostCloseModalVisible(true);
            setLoading(false);
            return { redirected: true };
          } else if (!storeOpsData) {
            return response;
          }
        }
      }
    } else {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();
      trace("Till", "storeOps(normal) openEvents", { count: tillEvents.length, date: tillEvents[0]?.openingTime?.split(" ")[0], businessDate: getTillBusinessDate(tillEvents[0]) });
      if (tillEvents.length > 0) {
        const currentDate = dayjs().format("YYYY-MM-DD");
        // BUG-2171: see the NXT branch above.
        const tillEventDate = getTillBusinessDate(tillEvents[0]);
        if (!isPastBusinessDay(tillEvents[0])) {
          return await getStoreOps(bunitId);
        } else if (posConfig?.enableAutoStoreClose !== "Y") {
          trace("Till", "day change but auto close disabled — continuing billing", { currentDate, tillEventDate });
          return await getStoreOps(bunitId);
        } else {
          trace("Till", "day change detected → /close-till", { currentDate, tillEventDate });
          const activeTillSession = useSessionStore.getState().tillSession;
          if (!activeTillSession) {
            trace("Till", "day change: no tillSession — orphaned open events, closing silently");
            await db.tillEvents.where("tillStatus").equals("open").modify({ tillStatus: "closed", isSynced: 1 });
            return await getStoreOps(bunitId);
          }
          setLoading(false);
          history.push("/close-till");
          return { redirected: true };
        }
      } else {
        return await getStoreOps(bunitId);
      }
    }
  };

  // Add handlers for the modal buttons
  const handlePostCloseContinue = async () => {
    setPostCloseModalVisible(false);
    setLoading(true);

    try {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();

      if (tillEvents.length > 0) {
        const tillSessionId = tillEvents[0]?.tillSessionId; // 🔹 rename event → currentEvent

        await db.ordersData
          .where("tillSessionId")
          .equals(tillSessionId)
          .modify((order) => {
            order.tillStatus = "closed";
          });

        await db.paymentsData
          .where("tillSessionId")
          .equals(tillSessionId)
          .modify((payment) => {
            payment.tillStatus = "closed";
          });

        await db.tillEvents
          .where("tillSessionId")
          .equals(tillSessionId)
          .modify((tillEvent) => {
            tillEvent.tillStatus = "closed";
            tillEvent.isSynced = 1;
            tillEvent.user = useAuthStore.getState().userData?.user;
          });
      }

      const userData = useAuthStore.getState().userData || {};
      const userid = userData?.user_id;
      // Use the date already computed from server response (shown in modal), not dayjs().add(1, "day")
      const nextBusinessDate = dayjs(postCloseData.newBusinessDate, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss");
      const response = await getStoreOps(JSON.parse(localStorage.getItem("tillValue"))?.cSBunitID, nextBusinessDate);
      if (response?.status === 200) {
        const storeOpsData = response?.data?.data?.getStoreOps;
        if (storeOpsData?.status === "OP") {
          useSessionStore.getState().setNextBusinessDate(nextBusinessDate);
          setTillValue({});
          history.push("/login");
        } else if (storeOpsData?.status === "CL" || storeOpsData === null) {
          const resStoreOps = await upsertStoreOps(JSON.parse(localStorage.getItem("tillValue"))?.cSBunitID, userid, nextBusinessDate);
          const upsertData = resStoreOps?.data?.data?.upsertStoreOps;

          if (upsertData?.status === "200") {
            useSessionStore.getState().setNextBusinessDate(nextBusinessDate);
            setTillValue({});
            history.push("/login");
          } else {
            message.error(upsertData?.message);
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
        message.error("Could not reach the server. Please check your connection and try again.");
      }
    } catch (error) {
      console.error("Error in handlePostCloseContinue:", error);
      setLoading(false);
      message.error("Could not reach the server. Please check your connection and try again.");
    }
  };

  const handlePostCloseCancel = () => {
    setPostCloseModalVisible(false);
    // Logout logic
    onUserModal();
  };

  const parseRemarksProducts = (remarks) => {
    try {
      const match = remarks.match(/Result:\s*(\[.*\])/);
      if (match && match[1]) {
        let arrStr = match[1];

        // ✅ Quote keys (m_product_id → "m_product_id")
        arrStr = arrStr.replace(/(\w+):/g, '"$1":');

        // ✅ Quote string values that are not already quoted/null
        arrStr = arrStr.replace(/:"([^",\]\}]*)"(?![,\]\}])/g, (m, p1) => {
          // already quoted string, leave it
          return m;
        });
        arrStr = arrStr.replace(/:"?([^",\]\}]+)"?(?=[,\]\}])/g, (m, p1) => {
          if (p1 === "null") return ":null"; // keep null
          return `:"${p1.trim()}"`;
        });

        return JSON.parse(arrStr);
      }
    } catch (err) {
      console.error("Error parsing remarks:", err, remarks);
    }
    return [];
  };

  useEffect(() => {
    const runAsync = async () => {
    // Hydrate POS module stores now that we're entering the POS module.
    // These are kept out of App.js boot so non-POS modules (Inventory,
    // PurchaseOrder, etc.) don't pay the cost of loading POS state.
    await Promise.all([
      usePOSConfigStore.persist.rehydrate(),
      useCartStore.persist.rehydrate(),
      useSessionStore.persist.rehydrate(),
      useTransactionStore.persist.rehydrate(),
      useRestaurantStore.persist.rehydrate(),
      useReferenceStore.persist.rehydrate(),
    ]);

    // FIX 4: Recovery for stale tillSession on app restart
    // If a tillSession exists with "open" status but the till was never properly
    // opened in this session (no matching tillEvent in DB), clear the stale session
    // so the user can proceed with till selection without being blocked.
    const existingTillSession = useSessionStore.getState().tillSession;
    trace("Till", "stale check start", {
      hasTillSession: !!existingTillSession,
      tillStatus: existingTillSession?.tillStatus,
      tillSessionId: existingTillSession?.tillSessionId?.slice(0, 8),
    });
    if (existingTillSession && existingTillSession.tillStatus === "open") {
      try {
        const matchingEvents = await db.tillEvents
          .where("tillSessionId")
          .equals(existingTillSession.tillSessionId)
          .toArray();
        trace("Till", "stale check DB result", { matchCount: matchingEvents?.length });
        if ((!matchingEvents || matchingEvents.length === 0) && !isDbBridgeAvailable()) {
          // BUG-2081: empty result may mean the Electron IPC bridge is
          // momentarily unreachable, not that the session is actually stale —
          // preserve it the same way a real DB error is already preserved
          // below, instead of clearing a possibly-still-valid session.
          trace("Till", "stale check inconclusive — DB bridge unavailable, preserving session");
        } else if (!matchingEvents || matchingEvents.length === 0) {
          // Stale session from a previous run — clear it so user can proceed
          trace("Till", "stale → clearing tillSession");
          console.warn("Clearing stale tillSession (no matching tillEvent in DB):", existingTillSession.tillSessionId);
          useSessionStore.getState().setTillSession(null);
        }
      } catch (err) {
        console.error("Error checking tillSession recovery:", err);
        trace("Till", "stale check DB ERROR — preserving session", { error: err?.message });
        // On DB error, preserve the session — it may still be valid.
        // handleStoreOpsService will detect a day-change if there is one.
      }
    }

    // BUG-1564: If till session is valid and from today, skip till selection
    // and go directly to /pos. This handles browser refresh in CW Browser where
    // the URL resets to / → /till instead of staying at /pos.
    // BUG-1994: same fast-forward gap as App.js's AuthRedirect — must not
    // resume a session left open by a different, previously-logged-in user.
    // A mismatch here just falls through to the normal Till.js flow below,
    // which fetches tills for the *current* user and rejects them if they
    // have no access, instead of silently reusing the stale tillData.
    const activeSession = useSessionStore.getState().tillSession;
    const rehydratedTillData = useAuthStore.getState().tillData;
    const rehydratedPosConfig = usePOSConfigStore.getState().posConfig;
    const tillDataOwner = useAuthStore.getState().tillDataOwner;
    const currentIdentity = username || email || null;
    const identityMatches = sessionOwnerMatchesCurrentUser(tillDataOwner, currentIdentity);
    if (activeSession?.tillStatus === "open" && rehydratedTillData?.tillAccess && rehydratedPosConfig && identityMatches) {
      try {
        const sessionEvents = await db.tillEvents
          .where("tillSessionId")
          .equals(activeSession.tillSessionId)
          .toArray();
        const openEvent = sessionEvents.find((e) => e.tillStatus === "open");
        if (openEvent) {
          const tillDate = getTillBusinessDate(openEvent);
          // BUG-1902: when Enable Auto Close is off (posConfig.enableAutoStoreClose !== "Y"),
          // billing continues across midnight on the same open till — a date rollover alone
          // must not force /close-till, only an actual server-side day change should.
          // BUG-2171: business date, not opening date (next-date session opened last evening).
          if (!isPastBusinessDay(openEvent) || rehydratedPosConfig?.enableAutoStoreClose !== "Y") {
            // TSK-2997: resolve from the till's own mode instead of a hardcoded /pos,
            // so estimate/production tills don't take an extra hop through the gate.
            const fastForwardTo = pickDefaultRoute({
              posConfig: rehydratedPosConfig,
              tillaccess: parseTillAccess(rehydratedTillData),
            });
            trace("Till", "BUG-1564: active session usable, fast-forwarding", { to: fastForwardTo, tillDate, enableAutoStoreClose: rehydratedPosConfig?.enableAutoStoreClose });
            history.push(fastForwardTo);
            return;
          }
        }
      } catch (err) {
        trace("Till", "BUG-1564: session check failed, continuing normal flow", { error: err?.message });
      }
    }

    const tillRegistrations = await db.tillRegistrations.toArray();
    const lastUpdatedTime = useSessionStore.getState().lastUpdatedTime;
    // PRD tills never run processSync (Login.js syncs docTypes/UOM instead), so
    // lastUpdatedTime never gets set for them — this check would otherwise fire
    // on every login once they register.
    if (tillRegistrations.length > 0 && !lastUpdatedTime && usePOSConfigStore.getState().posType !== "PRD") {
      const productCount = await db.products.count();
      if (productCount === 0) {
        setResumeSetupVisible(true);
      }
    }
    const posType = usePOSConfigStore.getState().posType;
    const posConfig = usePOSConfigStore.getState().posConfig;
    if (runEffect) {
      setRunEffect(!runEffect);
      const nameTill = tillValue?.name;
      // TIC-10115: which branch we take here decides whether a stale backend
      // till-lock (from a logout that never released it) gets masked by the
      // local resume path or actually surfaces via a fresh registration.
      // db.tillRegistrations is append-only (see .add() call sites below) —
      // nothing in the app ever clears it, so a device that has been through
      // more than one till registration carries every prior till's row
      // forever. This gate only checks .length > 0, not which till it's
      // for, so list the actual rows out to catch that "two tills in local
      // data" case directly in the trace instead of just a count.
      trace("Till", "resume-vs-fresh branch check", {
        nameTill,
        hasIdentity: !!(username || email),
        hasToken: !!cleanToken,
        tillRegistrationsCount: tillRegistrations.length,
        tillRegistrationsDetail: tillRegistrations.map((r) => ({
          till: r?.tillAccess?.cwrTill?.till,
          cwrTillRegHistoryId: r?.tillHistory?.[0]?.cwrTillRegHistoryId,
          time: r?.time,
        })),
        willResume: !!(nameTill && (username || email) && cleanToken && tillRegistrations.length > 0),
      });
      if (nameTill && (username || email) && cleanToken && tillRegistrations.length > 0) {
        setLoading(true);
        const userData = posTillUser(authHeaders);
        const syncSuccess = await syncTillData(userData, authHeaders);
        let tillData = useAuthStore.getState().tillData;
        if (!tillData || !syncSuccess) {
          console.warn("[Till] syncTillData failed or tillData missing after sync — falling back to getTillData()");
          trace("Till", "resume path failed — generic issue banner", {
            reason: syncSuccess === false ? "sync_failed" : "no_till_data",
            syncSuccess,
          });
          retryCountRef.current += 1;
          setLoading(false);
          setTillLoadError(syncSuccess === false ? "sync_failed" : "no_till_data");
          // BUG-2368: Retail Services did not answer — keep this device's linked till on screen
          // with a retry instead of listing every till (a refresh used to lose the link).
          if (shouldKeepLinkedTill(tillRegistrations, tillValue)) {
            trace("Till", "BUG-2368: tillData failed — keeping linked till", { till: tillValue?.name });
            setKeptLinkedTill(true);
            return;
          }
          getTillData();
          return;
        }
        setKeptLinkedTill(false);
        if (tillData) {
          const tillAccessData = tillData.tillAccess;
          if (!tillAccessData || !Array.isArray(tillAccessData) || tillAccessData?.length === 0) {
            console.warn("[Till] tillAccess empty or not an array — falling back to getTillData()");
            trace("Till", "resume path — empty tillAccess, generic issue banner", { tillAccessData });
            retryCountRef.current += 1;
            setLoading(false);
            setTillLoadError("no_till_access");
            getTillData({ keepLinkedOnEmpty: true });
            return;
          }
          const tillAccessIndex = (tillAccessData || [])?.findIndex((accessTill) => accessTill.cwrTill.till === nameTill);
          if (tillAccessIndex >= 0 || (tillAccessData && typeof tillAccessData === "object" && !Array.isArray(tillAccessData))) {
            if (islocked) {
              try {
                // New object (not mutated in place) — Zustand/React compare tillData by
                // reference, so reusing the same object here would make this update
                // invisible to any component subscribed via useAuthStore((s) => s.tillData).
                tillData = {
                  ...tillData,
                  tillAccess: tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData,
                  time: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                };
                useAuthStore.getState().setUsername(username);
                useAuthStore.getState().setTillData(tillData);
              } catch (err) {
                console.error("Error during unlock till data lookup:", err);
              } finally {
                // Always clear lock state even if till data lookup fails
                useSessionStore.getState().setLocked(false);
              }
              setTillValue({});
              // TSK-2997: a PRD till used to always land on /production here, even when
              // it is an RM-Issue till — mirror Login/index.js and branch on the flags.
              const tillMode = getTillMode(posConfig);
              if (posType === "PRD") {
                history.push(getTillModeRoute(tillMode === TILL_MODES.PRODUCTION_RM_ISSUE ? TILL_MODES.PRODUCTION_RM_ISSUE : TILL_MODES.PRODUCTION));
              } else if (tillMode === TILL_MODES.ESTIMATE) {
                history.push("/estimate");
              } else {
                history.push("/pos");
              }
            } else if (posType === "PRD") {
              setTillValue({});
              history.push(`/login`);
            } else {
              const handleStoreOps = async () => {
                try {
                  // New object (not mutated in place) — see note above; keeps the
                  // reference change visible to Zustand/React subscribers.
                  tillData = {
                    ...tillData,
                    tillAccess: tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData,
                    time: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                  };
                  useAuthStore.getState().setTillData(tillData);
                  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
                  const matchedRep = salesReps.find((rep) => rep.name === username);
                  if (matchedRep) {
                    setTillValue({});
                    history.push(`/login`);
                  } else {
                    await reholdTillAtLogin(tillData);
                    const result = await handleStoreOpsService(tillValue?.cSBunitID);
                    if (result?.redirected) return;
                    const storeOpsData = result?.data?.data?.getStoreOps;
                    if (result?.data?.data?.getStoreOps?.status === "ERR") {
                      setLoading(false);
                      const remarks = result?.data?.data?.getStoreOps?.remarks;
                      const products = parseRemarksProducts(remarks);
                      if (products.length > 0) {
                        setErrorProducts(products);
                        setErrorModalVisible(true);
                      } else {
                        message.error(remarks || `${messages.errors.system.unexpected_error}`);
                      }
                      return;
                    } else if (result?.data?.data?.getStoreOps?.status === "WAR") {
                      message.error(result?.data?.data?.getStoreOps?.remarks);
                    }
                    if (!storeOpsData) {
                      const resStoreOps = await upsertStoreOps(tillValue?.cSBunitID, tillData.tillAccess.csUserId);
                      const upsertData = resStoreOps?.data?.data?.upsertStoreOps;
                      if (upsertData?.status === "200") {
                        setTillValue({});
                        history.push(`/login`);
                      } else {
                        message.error(upsertData?.message);
                        setLoading(false);
                      }
                    } else if (storeOpsData.status === "OP") {
                      setTillValue({});
                      history.push(`/login`);
                    } else {
                      setTillValue({});
                      setLoading(false);
                      Modal.confirm({
                        title: `This till has been closed "${dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")}"`,
                        icon: null,
                        cancelText: "",
                        okText: "Okay",
                        okButtonProps: { style: { display: "inline-block" } },
                        cancelButtonProps: { style: { display: "none" } }, // Disable the cancel button
                        onOk() {
                          getTillData();
                        },
                      });
                    }
                  }
                } catch (error) {
                  setTillValue({});
                  console.error("An error occurred:", error);
                  message.error(error);
                  setLoading(false);
                }
              };
              handleStoreOps();
            }
          } else {
            setTillValue({});
            setLoading(false);
            errorMessage("Login Failed", "User not configured for this Till", "user");
          }
        }
      } else {
        getTillData();
      }
    }
    };
    runAsync();
  }, [runEffect]);

  // BUG-2672: keepLinkedOnEmpty — called from the resume path after tillData gave no till access.
  const getTillData = async ({ keepLinkedOnEmpty = false } = {}) => {
    if (authHeaders && cleanToken && (username || email)) {
      setLoading(true);
      try {
        let userData = useAuthStore.getState().userData;
        // SSO bootstrap: if auth cookies exist but userData is missing, fetch it.
        // Also re-fetch when cached userData belongs to a different user than the
        // one currently authenticated via cookies (stale cache from a prior user
        // on this browser/device) — otherwise the wrong user_id gets sent to getTills().
        // NOTE: the User object's display-name field is "user", not "username".
        const identityMismatch = authHeaders?.username && userData?.user && userData.user !== authHeaders.username;
        if (!userData?.user_id || identityMismatch) {
          if (identityMismatch) {
            console.warn("[Till] Cached userData identity mismatch — re-fetching", { cached: userData?.user, current: authHeaders?.username });
          }
          try {
            const { getGlobalParameters } = await import("../../services/generic");
            const gpRes = await getGlobalParameters();
            if (gpRes?.status === 200) {
              const parsed = JSON.parse(gpRes.data.data.getGlobalParameters);
              useAuthStore.getState().setUserData(parsed.User);
              userData = parsed.User;
            }
          } catch (err) {
            console.error("[Till] SSO bootstrap failed:", err);
          }
        }
        const userid = userData?.user_id;
        if (!userid) {
          console.warn("[Till] getTillData: no user_id — session expired, redirecting to sign-in");
          window.location.href = "/sign-in";
          return;
        }
        const response = await getTills(userid);
        const tillsData = response?.data?.data?.getTills ?? [];
        trace("Till", "getTillData response", {
          userid,
          count: tillsData.length,
          tills: tillsData.map((t) => ({ name: t?.name, status: t?.status, linked: t?.linked })),
        });
        if (tillsData.length === 0) {
          console.warn("[Till] getTillData: API returned 0 tills for user", userid);
          // BUG-2672: from the resume path, no tills either while this device holds a registration
          // for its till: keep that till with Retry, and keep the resume path's reason (no_till_access).
          if (keepLinkedOnEmpty && shouldKeepLinkedTill(await db.tillRegistrations.toArray(), tillValue)) {
            trace("Till", "BUG-2672: getTills empty — keeping linked till", { till: tillValue?.name });
            setKeptLinkedTill(true);
          } else {
            setTillLoadError("no_tills_found");
          }
        } else {
          retryCountRef.current = 0;
          setTillLoadError(null);
        }
        const transformedData = tillsData.reduce((result, item) => {
          const { name } = item;
          const existingGroupIndex = result.findIndex((group) => group[name]);
          if (existingGroupIndex === -1) {
            result.push({ [name]: [item] });
          } else {
            result[existingGroupIndex][name].push(item);
          }
          return result;
        }, []);
        setTills(transformedData);
      } catch (error) {
        retryCountRef.current += 1;
        trace("Till", "getTillData FAILED", {
          message: error?.message,
          httpStatus: error?.response?.status,
          responseBody: error?.response?.data,
        });
        if (!error.response) {
          console.error("Network error: Unable to connect to the server", error);
          setTillLoadError("network");
        } else {
          console.error("Error while fetching till data:", error);
          setTillLoadError("api_error");
        }
      } finally {
        setLoading(false);
      }
    } else {
      console.warn("[Till] getTillData: missing auth credentials — cannot fetch tills");
      setTillLoadError("no_auth");
      setLoading(false);
    }
  };

  // BUG-2443: the server's active registration rows for one till (getTills), plus the till row itself.
  const readTillHolders = async (cwrTillID) => {
    const userid = useAuthStore.getState().userData?.user_id;
    if (!userid || !cwrTillID) return null;
    const res = await getTills(userid);
    return (res?.data?.data?.getTills || []).find((t) => t?.cwrTillID === cwrTillID) || null;
  };

  // BUG-2443: the till is linked to another device. Show which one and let the cashier move it here.
  const confirmUseTillHere = async (cwrTillID) => {
    let till = null;
    let holder = null;
    try {
      till = await readTillHolders(cwrTillID);
      holder = classifyTillHold({ activeRows: till?.tillHistory, heldId: null, deviceId: getPosDeviceId() }).row || null;
    } catch (err) {
      console.warn("[Till] BUG-2443: could not read the device holding the till", err);
    }
    const lines = describeTillHolder(holder, till);
    trace("Till", "BUG-2443: till linked to another device — Use POS Here offered", { cwrTillID, holder, lines });
    return new Promise((resolve) => {
      Modal.confirm({
        title: "This till is already in use in another browser profile or device",
        icon: null,
        content: (
          <div>
            {lines.map((l) => (
              <div key={l}>{l}</div>
            ))}
            <div style={{ marginTop: 12 }}>
              Only one browser profile or device can bill on a till at a time. Use POS Here moves the till here. Billing stops on the other one; bills
              already saved there are sent to the server before it closes.
            </div>
          </div>
        ),
        okText: "Use POS Here",
        cancelText: "Cancel",
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
  };

  // Two places never bill on one till: the till is held in another browser profile or
  // device. It is not taken from there (its bills saved offline would be numbered over);
  // the cashier closes it there and presses Check Again, or picks another till.
  const waitForTillRelease = (cwrTillID, rows) => {
    const holder = classifyTillHold({ activeRows: rows, heldId: null, deviceId: getPosDeviceId() }).row || null;
    const lines = describeTillHolder(holder, null);
    trace("Till", "till in use elsewhere — Check Again offered", { cwrTillID, holder, lines });
    return new Promise((resolve) => {
      Modal.confirm({
        title: "This till is in use in another browser profile or device",
        icon: null,
        content: (
          <div>
            {lines.map((l) => (
              <div key={l}>{l}</div>
            ))}
            <div style={{ marginTop: 12 }}>
              Only one browser profile or device can bill on a till at a time. Run Close Till on that browser profile or device (its saved bills are
              sent to the server first), then press Check Again here. If that browser profile or device is no longer in use, please contact your
              back office team to unlink this till.
            </div>
          </div>
        ),
        okText: "Check Again",
        cancelText: "Choose another till",
        onOk: () => {
          setLoading(true);
          resolve(true);
        },
        onCancel: () => resolve(false),
      });
    });
  };

  const newSyncId = () => uuidv4().replace(/-/g, "").toUpperCase();

  // BUG-2443: tillRegistration, and when the backend answers "already linked to another
  // device": the till is never taken from another place (registerTillWithUseHere). The
  // Use POS Here popup (unlinkTill + register again) stays only for this browser's own
  // registration and for estimate tills. Restaurant and production tills keep the old error.
  const registerTillHere = (cwrTillID, search_key) => {
    const { posType, posConfig } = usePOSConfigStore.getState();
    return registerTillWithUseHere({
      register: (syncId) => tillRegistration(syncId, cwrTillID, search_key, timeStamp(), username),
      unlink: () => unlinkTill(cwrTillID),
      confirm: async () => {
        const useHere = await confirmUseTillHere(cwrTillID);
        if (useHere) setLoading(true);
        return useHere;
      },
      readHolders: async () => (await readTillHolders(cwrTillID))?.tillHistory || null,
      waitForRelease: (rows) => waitForTillRelease(cwrTillID, rows),
      onAsk: () => setLoading(false),
      // Read at the moment of registering: onRegistration has just loaded this till's posConfig.
      moveSupported: isTillMoveSupported({
        tillAccessController: parseTillAccess(useAuthStore.getState().tillData),
        posType,
        posConfig,
      }),
      takeoverAllowed: isEstimateOnlyTill(posConfig),
      newSyncId,
      log: (msg, data) => trace("Till", `BUG-2443: ${msg}`, { cwrTillID, ...data }),
    });
  };

  // BUG-2443: at login, hold the till again for this device when Close Till (LO) left it
  // free (utils/tillDeviceRegistration reholdTillIfFree). Any other state keeps today's
  // flow; the POS screen's TillMovedGuard handles a till moved to another device.
  const reholdTillAtLogin = async (tillData) => {
    try {
      await reholdTillIfFree({
        db,
        tillData,
        posType: usePOSConfigStore.getState().posType,
        posConfig: usePOSConfigStore.getState().posConfig,
        readTill: readTillHolders,
        register: (syncId, searchKey) => tillRegistration(syncId, tillData.tillAccess.cwrTill.cwrTillID, searchKey, timeStamp(), username),
        newSyncId,
        log: (msg, data) => trace("Till", `BUG-2443: ${msg}`, data),
      });
    } catch (err) {
      // Login continues exactly as before; the trace tells support why the till was not re-held.
      console.warn("[Till] BUG-2443: re-hold at login failed", err);
      trace("Till", "BUG-2443: re-hold at login failed", { message: err?.message });
    }
  };

  const callTillRegistration = async (cwrTillID, search_key) => {
    try {
      const { tillData, syncId, declined } = await registerTillHere(cwrTillID, search_key);
      if (declined) {
        // The till is in use elsewhere and the cashier chose another till: no error popup.
        setTillValue({});
        return;
      }
      // TIC-10115: the exact status/message the backend returned for THIS
      // registration attempt — "200" = registered, "201"/other = rejected
      // (e.g. "This Till is already linked to another device" from the
      // TILL_ACTIVE_CHECK guard when a prior session's release never fired).
      trace("Till", "callTillRegistration result", {
        cwrTillID,
        search_key,
        status: tillData?.status,
        message: tillData?.message,
        tillAccessCount: tillData?.tillAccess?.length,
      });
      if (tillData?.status === "200" && tillData.tillAccess?.length > 0) {
        localStorage.setItem("syncId", syncId);
        const cwrTill0 = tillData.tillAccess[0].cwrTill || {};
        const serverSeq0 = cwrTill0.nextAssignedNumber || 0;
        const localMax0 = await getLocalMaxSequence(db, cwrTill0.prefix);
        const prevCounter0 = useSessionStore.getState().documentSequence;
        const chosenSeq0 = resolveInitialDocumentSequence(serverSeq0, localMax0);
        useSessionStore.getState().setDocumentSequence(chosenSeq0);
        logSequenceEvent(
          "init",
          { source: "till-registration", prefix: cwrTill0.prefix, serverSeq: serverSeq0, localMax: localMax0, chosen: chosenSeq0, prevCounter: prevCounter0 },
          db
        );

        const preSeq0 = cwrTill0.preorderSequence ? { ...cwrTill0.preorderSequence } : null;
        if (preSeq0) {
          const lpMax0 = await getLocalMaxSequence(db, preSeq0.prefix);
          preSeq0.nextNo = Math.max(preSeq0.nextNo || 0, lpMax0);
        }
        useSessionStore.getState().setPreorderSequence(preSeq0);
        // TIC/BUG advance-seq-race diagnostic (temporary): every WRITE to the shared
        // preorderSequence session value, everywhere it happens, so a future backup
        // export can line up "when was this value set/cleared" against "what did an
        // order save read" by timestamp and settle whether a race is real.
        logSequenceEvent("preorder-seq-write", { source: "till-registration", value: preSeq0, till: cwrTill0.prefix }, db);

        const canSeq0 = cwrTill0.cancelledOrderSequence ? { ...cwrTill0.cancelledOrderSequence } : null;
        if (canSeq0) {
          const lcMax0 = await getLocalMaxSequence(db, canSeq0.prefix);
          canSeq0.nextNo = Math.max(canSeq0.nextNo || 0, lcMax0);
        }
        useSessionStore.getState().setCancelledOrderSequence(canSeq0);

        const seqPrefixes0 = [cwrTill0.prefix, preSeq0?.prefix, canSeq0?.prefix].filter(Boolean);
        if (new Set(seqPrefixes0).size !== seqPrefixes0.length) {
          console.error("[SEQ] Duplicate prefixes detected — falling back to single sequence mode");
          useSessionStore.getState().setPreorderSequence(null);
          useSessionStore.getState().setCancelledOrderSequence(null);
          logSequenceEvent(
            "preorder-seq-write",
            { source: "till-registration-duplicate-prefix-fallback", value: null, till: cwrTill0.prefix, seqPrefixes: seqPrefixes0 },
            db
          );
        }

        // TIC-10115: db.tillRegistrations is append-only — this add() never checks
        // for or clears a prior row from an earlier till on this device, so trace
        // what was already there right before adding the new one. If priorRows is
        // non-empty and its till differs from the one being added now, that's the
        // "two tills in local data" state landing at the exact moment it's created.
        const priorRows0 = await db.tillRegistrations.toArray();
        trace("Till", "callTillRegistration: about to add till registration row", {
          priorRowsCount: priorRows0.length,
          priorTills: priorRows0.map((r) => r?.tillAccess?.[0]?.cwrTill?.till ?? r?.tillAccess?.cwrTill?.till),
          addingTill: cwrTill0.till,
        });
        await db.tillRegistrations.add(tillData);
        const activityResponse = await upsertPOSActivity(tillData);
        if (activityResponse?.data?.data?.upsertPOSActivity?.status === "200") {
          setTillValue({});
          history.push(`/login`);
        }
      } else {
        setTillValue({});
        throw new Error(tillData?.message || "Till registration failed.");
      }
    } catch (error) {
      setTillValue({});
      trace("Till", "callTillRegistration FAILED — modal shown to user", {
        cwrTillID,
        modalTitle: error?.message || "An unexpected error occurred.",
        httpStatus: error?.response?.status,
      });
      console.error("An error occurred:", error);
      setLoading(false);
      Modal.error({
        title: error.message || "An unexpected error occurred.",
        onOk() {
          // Stay on till selection — just dismiss the modal
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const onRegistration = async (search_key, csbUnitId, csUserId, cwrTillID) => {
    const userData = useAuthStore.getState().userData;
    const userid = userData?.user_id;
    let posConfig = {};
    if (username || email) {
      try {
        setLoading(true);
        setRegistrationError(null);
        const pickedTillValue = useAuthStore.getState().tillValue;
        setLastRegistrationArgs({ search_key, csbUnitId, csUserId, cwrTillID, tillValue: pickedTillValue });
        setRegistrationStep(0);
        const userData = posTillUser(authHeaders);
        const syncSuccess = await syncTillData(userData, authHeaders);
        // BUG-2368: without a fresh tillData the saved one (one till, not the list) would be read
        // and reported as "No till access data found". Stop here and let the cashier retry.
        if (!syncSuccess) {
          trace("Till", "BUG-2368: tillData failed during registration", { cwrTillID });
          const linkedTill = currentLinkedTill(await db.tillRegistrations.toArray());
          const previous = previousTillValueRef.current;
          if (linkedTill?.name && linkedTill.name !== pickedTillValue?.name && previous?.name === linkedTill.name) {
            // The pick is not registered: a reload must resume the till this device is linked to.
            useAuthStore.getState().setTillValue(previous);
          }
          setRegistrationError({ step: 0, message: "Could not load till access from Retail Services. Check the connection and try again." });
          setLoading(false);
          return;
        }
        let tillData = useAuthStore.getState().tillData;
        useAuthStore.getState().setTillData(tillData);
        setRegistrationStep(1);
        const posConfigResponse = await posConfigService(cwrTillID);
        if (posConfigResponse?.data?.data?.getPOSConfig?.length > 0) {
          posConfig = posConfigResponse.data.data.getPOSConfig[0];
          const posConfigData = JSON.parse(posConfig?.configJson || "{}");
          const feedbackData = JSON.parse(posConfig?.feedback || "{}");
          const registrationTypes = JSON.parse(posConfig?.registrationTypes || "[]");
          useReferenceStore.getState().setRegistrationTypes(registrationTypes);
          usePOSConfigStore.getState().setPosConfig(posConfigData);
          usePOSConfigStore.getState().setPosType(posConfig.posType);
          localStorage.setItem("posConfigData", JSON.stringify(posConfig));
          useReferenceStore.getState().setFeedbackJson(feedbackData);
        } else {
          setLoading(false);
          errorMessage("Login Failed", "Error in getting POS configuration");
          return;
        }
        let matchedRep;
        if (tillData !== null && tillData !== undefined) {
          const tillAccessData = tillData.tillAccess;
          if (!tillAccessData || !Array.isArray(tillAccessData) || tillAccessData?.length === 0) {
            setLoading(false);
            errorMessage("Till Setup Error", "No till access data found. Please contact your administrator to configure till access for your account.");
            return;
          }
          const nameTill = useAuthStore.getState().tillValue?.name;
          const tillAccessIndex = (tillAccessData || [])?.findIndex((accessTill) => accessTill.cwrTill.till === nameTill);
          if (tillAccessIndex >= 0 || (tillAccessData && typeof tillAccessData === "object" && !Array.isArray(tillAccessData))) {
            // New object (not mutated in place). tillData here is the same reference
            // already sitting in the auth store (read at the top of this function) —
            // mutating tillAccess/time on it directly and passing it back into
            // setTillData() is a no-op from Zustand/React's point of view (same
            // reference in, same reference out), so any component subscribed via
            // useAuthStore((s) => s.tillData) — e.g. AppShell computing bunitId for
            // the WebSocket — never re-renders and never sees the resolved till.
            tillData = {
              ...tillData,
              // Persist the processed tillAccess (single object, not array) so CloseTill
              // can read tillData.tillAccess.csBunit without getting undefined.
              tillAccess: tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData,
              time: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            };
            useAuthStore.getState().setTillData(tillData);
            trace("Till", "onRegistration: setTillData after tillAccess fix", {
              isArray: Array.isArray(tillData.tillAccess),
              hasCsBunit: !!tillData.tillAccess?.csBunit,
            });
            const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
            matchedRep = salesReps.find((rep) => rep.name === username);
          }
        }
        if (posConfig?.posType === "PRD") {
          setRegistrationStep(4);
          await callTillRegistration(cwrTillID, search_key);
        } else if (matchedRep) {
          setRegistrationStep(4);
          history.push("/login");
        } else {
          setRegistrationStep(2);
          const result = await handleStoreOpsService(csbUnitId);
          if (result?.redirected) return;
          if (result?.data?.data?.getStoreOps?.status === "ERR") {
            setLoading(false);
            const remarks = result?.data?.data?.getStoreOps?.remarks;
            const products = parseRemarksProducts(remarks);
            if (products.length > 0) {
              setErrorProducts(products);
              setErrorModalVisible(true);
            } else {
              message.error(remarks || `${messages.errors.system.unexpected_error}`);
            }
            return;
          } else if (result?.data?.data?.getStoreOps?.status === "WAR") {
            message.error(result?.data?.data?.getStoreOps?.remarks);
          }
          if (result?.data?.data?.getStoreOps === null) {
            const resStoreOps = await upsertStoreOps(csbUnitId, userid);
            if (resStoreOps?.data?.data?.upsertStoreOps?.status === "200") {
              setRegistrationStep(3);
              const { tillData, syncId, declined } = await registerTillHere(cwrTillID, search_key);
              if (declined) {
                // The till is in use elsewhere and the cashier chose another till.
                setTillValue({});
                setLoading(false);
                return;
              }
              localStorage.setItem("syncId", syncId);
              if (tillData?.status === "200") {
                // TIC-10115: same append-only gap as callTillRegistration's add() above —
                // trace prior rows right before this (non-PRD/storeOps) path adds its own.
                const priorRows1 = await db.tillRegistrations.toArray();
                trace("Till", "onRegistration (storeOps path): about to add till registration row", {
                  priorRowsCount: priorRows1.length,
                  priorTills: priorRows1.map((r) => r?.tillAccess?.[0]?.cwrTill?.till ?? r?.tillAccess?.cwrTill?.till),
                  addingTill: tillData?.tillAccess?.[0]?.cwrTill?.till,
                });
                await db.tillRegistrations.add(tillData);
                const cwrTill1 = tillData.tillAccess[0].cwrTill || {};
                const serverSeq1 = cwrTill1.nextAssignedNumber || 0;
                const localMax1 = await getLocalMaxSequence(db, cwrTill1.prefix);
                const prevCounter1 = useSessionStore.getState().documentSequence;
                const chosenSeq1 = resolveInitialDocumentSequence(serverSeq1, localMax1);
                useSessionStore.getState().setDocumentSequence(chosenSeq1);
                logSequenceEvent(
                  "init",
                  { source: "till-registration-storeops", prefix: cwrTill1.prefix, serverSeq: serverSeq1, localMax: localMax1, chosen: chosenSeq1, prevCounter: prevCounter1 },
                  db
                );

                const preSeq1 = cwrTill1.preorderSequence ? { ...cwrTill1.preorderSequence } : null;
                if (preSeq1) {
                  const lpMax1 = await getLocalMaxSequence(db, preSeq1.prefix);
                  preSeq1.nextNo = Math.max(preSeq1.nextNo || 0, lpMax1);
                }
                useSessionStore.getState().setPreorderSequence(preSeq1);
                // TIC/BUG advance-seq-race diagnostic (temporary): see matching entry
                // in the other registration path above — same reasoning.
                logSequenceEvent("preorder-seq-write", { source: "till-registration-storeops", value: preSeq1, till: cwrTill1.prefix }, db);

                const canSeq1 = cwrTill1.cancelledOrderSequence ? { ...cwrTill1.cancelledOrderSequence } : null;
                if (canSeq1) {
                  const lcMax1 = await getLocalMaxSequence(db, canSeq1.prefix);
                  canSeq1.nextNo = Math.max(canSeq1.nextNo || 0, lcMax1);
                }
                useSessionStore.getState().setCancelledOrderSequence(canSeq1);

                const seqPrefixes1 = [cwrTill1.prefix, preSeq1?.prefix, canSeq1?.prefix].filter(Boolean);
                if (new Set(seqPrefixes1).size !== seqPrefixes1.length) {
                  console.error("[SEQ] Duplicate prefixes detected — falling back to single sequence mode");
                  useSessionStore.getState().setPreorderSequence(null);
                  useSessionStore.getState().setCancelledOrderSequence(null);
                  logSequenceEvent(
                    "preorder-seq-write",
                    { source: "till-registration-storeops-duplicate-prefix-fallback", value: null, till: cwrTill1.prefix, seqPrefixes: seqPrefixes1 },
                    db
                  );
                }

                setLoading(false);
                const response = await upsertPOSActivity(tillData);
                if (response?.data?.data?.upsertPOSActivity?.status === 200 || response?.data?.data?.upsertPOSActivity?.status === "200") {
                  setRegistrationStep(4);
                  history.push(`/login`);
                }
              } else {
                setLoading(false);
                errorMessage(tillData.message);
              }
            } else {
              message.error(resStoreOps?.data?.data?.upsertStoreOps?.message);
              setTillValue({});
              setTimeout(() => {
                for (let key in localStorage) {
                  if (key !== "userData") {
                    localStorage.removeItem(key);
                  }
                }
                window.location.assign("/till");
              }, 3000);
            }
          } else if (result?.data?.data?.getStoreOps?.status === "OP") {
            setRegistrationStep(3);
            await callTillRegistration(cwrTillID, search_key);
          } else {
            setLoading(false);
            Modal.confirm({
              title: `This till has been closed "${dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")}"`,
              icon: null,
              cancelText: "",
              okText: "Okay",
              okButtonProps: { style: { display: "inline-block" } },
              cancelButtonProps: { style: { display: "none" } }, // Disable the cancel button
              onOk() {
                Modal.destroyAll();
              },
            });
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setRegistrationError({ step: registrationStep, message: error.message || "An error occurred while fetching till data" });
        setLoading(false);
      }
    }
  };

  const onModalOkay = () => {
    setLoading(false);
    const keepKey = "userData"; // Replace with the key you want to keep
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      // BUG-2621: the local tables stay, so this browser keeps its device id.
      if (key !== keepKey && key !== POS_DEVICE_ID_KEY) {
        localStorage.removeItem(key);
      }
    }
  };

  // TSK-5406: every logout on this screen goes through signOutFromTillScreen. It keeps the till
  // session, the link, the local tables, lastUpdatedTime and the counters: the same user signs in
  // and resumes. It clears the POS's own login record (clearAuthCookies), not only the cookies.
  const onUserModal = async (narrowedTillData = null) => {
    setLogoutDialog(null);
    setLoading(true);
    await signOutFromTillScreen({ narrowedTillData, posType: usePOSConfigStore.getState().posType, redirectUrl });
  };

  const onLogoutClick = async () => {
    if (registrationStep >= 0 || logoutChecking) return;
    setLogoutChecking(true);
    try {
      const ctx = await readTillLogoutContext({
        db,
        authStore: useAuthStore,
        sessionStore: useSessionStore,
        posConfigStore: usePOSConfigStore,
        username,
        readServerTills: (userId) => readServerTillList(getTills, userId),
        deviceId: getPosDeviceId(),
      });
      const notes = [];
      let canClose = false;
      if (ctx.state === TILL_LOGOUT_STATE.OPEN_TODAY || ctx.state === TILL_LOGOUT_STATE.OPEN_PAST_DAY) {
        const blockers = await readCloseTillBlockers({
          posConfig: ctx.posConfig,
          narrowedTillData: ctx.narrowedTillData,
          parkedList: useSessionStore.getState().parkedList,
          cart: useCartStore.getState().cart,
          exchangeCart: useCartStore.getState().exchangeCart,
          readParkedBills: (tillId) => readServerParkedBills(cartHistory, tillId),
        });
        canClose = blockers.canClose;
        notes.push(...blockers.messages);
      }
      if (ctx.state === TILL_LOGOUT_STATE.OFFLINE) notes.push(OFFLINE_MESSAGE);
      if (ctx.state === TILL_LOGOUT_STATE.MOVED) notes.push(MOVED_MESSAGE);
      if (ctx.state === TILL_LOGOUT_STATE.OTHER_USER) notes.push(OTHER_USER_MESSAGE);
      if (ctx.unsentBills > 0) notes.push(unsentBillsMessage(ctx.unsentBills));
      trace("Till", "TSK-5406: logout asked", { state: ctx.state, reason: ctx.reason, canClose, unsentBills: ctx.unsentBills });
      setLogoutDialog({ ...ctx, canClose, notes });
    } catch (err) {
      // The local tables could not be read: a plain logout is still offered.
      console.error("[Till] TSK-5406: logout check failed:", err);
      setLogoutDialog({ state: TILL_LOGOUT_STATE.NONE, canClose: false, notes: [OFFLINE_MESSAGE], narrowedTillData: null });
    } finally {
      setLogoutChecking(false);
    }
  };

  const onCloseTillFromLogout = () => {
    const dialog = logoutDialog;
    if (!dialog?.canClose || !dialog.closePath || !dialog.narrowedTillData) return;
    setLogoutDialog(null);
    // Close Till reads tillData.tillAccess as this one till, as on the billing screen.
    useAuthStore.getState().setTillData(dialog.narrowedTillData);
    markCloseTillFromTillScreen(dialog.tillSessionId);
    trace("Till", "TSK-5406: Close Till from the Till screen", { path: dialog.closePath, state: dialog.state });
    history.push(dialog.closePath);
  };

  const errorMessage = (modalTitle, modalContent, user) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
      onOk: user ? () => onUserModal() : onModalOkay,
    });
  };

  // BUG-2368: a till other than the linked one is not registered while this device still has
  // unsent bills or an open till session (they would be sent under the new till / never closed).
  const onSelectTill = async (res) => {
    try {
      const block = await readTillSwitchBlock(db, { cwrTillID: res.cwrTillID, searchKey: res.searchKey, name: res.till });
      if (block) {
        trace("Till", "BUG-2368: till switch refused", { target: res.till, ...block });
        Modal.warning({ title: "Finish the current till first", content: tillSwitchBlockMessage(block), okText: "OK" });
        return;
      }
    } catch (err) {
      // Not able to read the local tables: do not let a different till be registered blind.
      console.error("[Till] BUG-2368: till switch check failed:", err);
      trace("Till", "BUG-2368: till switch check failed", { target: res.till, error: err?.message });
      message.error("Could not check this device's unsent bills. Please try again.");
      return;
    }
    previousTillValueRef.current = useAuthStore.getState().tillValue;
    useAuthStore.getState().setTillValue({
      search_key: res.searchKey,
      cwr_till_id: res.cwrTillID,
      name: res.till,
      cSBunitID: res.cSBunitID,
    });
    onRegistration(res.searchKey, res.cSBunitID, res.cSUserId, res.cwrTillID);
  };

  const onTill = () => {
    if (cleanToken !== "bearer undefined" && (email || username)) {
      setRunEffect(true);
    } else {
      history.push("/sign-in");
    }
  };

  // BUG-2672: an empty getTills list ([]) is no list. The linked till card shows while the list was
  // never loaded, or when it is kept on purpose; otherwise the "No Tills" panel (Retry) shows, so
  // the screen never ends with only a banner and nothing to click.
  const hasTillList = tills?.length > 0;
  const showLinkedTill = !hasTillList && !!tillValue?.search_key && (tills === undefined || keptLinkedTill);

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} className="spinLoader" spin />} spinning={loading}>
      {authHeaders ? (
        <Row className="till-select-row">
          <Col className="till-select-left-col" style={{ backgroundColor: "#F5FAFF" }} span={8}>
            <div className="till-select-left-panel" style={{ height: "100vh" }}>
              <Image className="till-select-logo" preview={false} src={logo} style={{ paddingTop: "4.5vh", paddingLeft: "2.6em", width: "93%" }} />
              <p className="till-select-welcome-text" style={{ fontFamily: "Inter", fontWeight: 600, fontSize: "1.8vw", paddingTop: "7vh", paddingLeft: "3em", color: "#0F0718" }}>
                Welcome to Point of Sale
                {multilingual && <span style={{ display: "block" }}>{t("Welcome to Point of Sale")}</span>}
              </p>
              <Image className="till-select-illustration" preview={false} src={laptop3} style={{ width: "30vw", marginLeft: "2em", height: "43vh" }} />
              <p className="till-select-footer-label" style={{ fontFamily: "Inter", fontWeight: 600, color: "#667085", fontSize: "13px", paddingTop: "7vh", paddingLeft: "3em" }}>Point of Sale </p>
              <p className="till-select-blurb" style={{ fontFamily: "Inter", fontWeight: 600, color: "#667085", fontSize: "0.9vw", paddingTop: "0.5em", paddingLeft: "3em", paddingRight: "5em" }}>
                {" "}
                Centralize the operations of your store, process transactions, manage inventory, follow orders, create reports of the store’s activities and much more!
              </p>
            </div>
          </Col>
          <Col className="till-select-right-col" span={16}>
            <div className="till-select-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "1.5rem 2rem" }}>
              <p
                className="till-select-title"
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 600,
                  fontSize: "1.25rem", // 20px
                  color: "#0F0718",
                  margin: 0,
                }}
              >
                {getMultilingualText("Select a Till to login")}
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
                {/* Home button hidden on Till screen: history.push("/") reloads Till (re-triggers getTills)
                    instead of navigating to CW Browser Home, and Home is not supported in POS2.
                <div
                  onClick={() => history.push("/")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      fontSize: "1rem",
                      color: "#0F0718",
                    }}
                  >
                    ← Home
                  </span>
                </div>
                */}
                <div
                  onClick={() => window.location.reload()}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <img src={SyncSide} alt="Refresh" style={{ height: "20px", width: "20px" }} />
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      fontSize: "1rem",
                      color: "#0F0718",
                      marginLeft: "0.5rem",
                    }}
                  >
                    Refresh
                  </span>
                </div>
                <div
                  onClick={() => history.push({ pathname: "/health", state: { from: "/till" } })}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                  }}
                >
                  <MedicineBoxOutlined style={{ fontSize: "16px", color: "#1890ff" }} />
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      fontSize: "1rem",
                      color: "#1890ff",
                      marginLeft: "0.5rem",
                    }}
                  >
                    Diagnostics
                  </span>
                </div>
                {/* TSK-5406: Logout (with Close Till when this device holds an open till session) */}
                <div
                  data-testid="till-screen-logout"
                  onClick={onLogoutClick}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: registrationStep >= 0 || logoutChecking ? "not-allowed" : "pointer",
                    opacity: registrationStep >= 0 || logoutChecking ? 0.5 : 1,
                    padding: "6px 12px",
                    borderRadius: "6px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                  }}
                >
                  {logoutChecking ? <LoadingOutlined style={{ fontSize: "16px", color: "#0F0718" }} /> : <LogoutOutlined style={{ fontSize: "16px", color: "#0F0718" }} />}
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      fontSize: "1rem",
                      color: "#0F0718",
                      marginLeft: "0.5rem",
                    }}
                  >
                    Logout
                  </span>
                </div>
              </div>
            </div>
            <Scrollbars style={{ height: "85vh" }}>
              {/* BUG-2368: Retail Services did not return the till access — the linked till stays, with a retry */}
              {keptLinkedTill && !hasTillList && tillValue?.search_key && !loading && (
                <Alert
                  type={retryCountRef.current >= MAX_RETRIES ? "error" : "warning"}
                  showIcon
                  style={{ margin: "0 2em 1em 2em" }}
                  message={tillLoadError === "no_till_access" ? "Retail Services returned no till access for this user" : "Could not load till access from Retail Services"}
                  description={
                    <span>
                      {`This device stays linked to till ${tillValue?.name}. Check the connection and try again. `}
                      <Button type="link" style={{ padding: 0, fontWeight: 600 }} onClick={onTill}>
                        Retry
                      </Button>
                      {" · "}
                      <Button
                        type="link"
                        style={{ padding: 0, fontWeight: 600 }}
                        onClick={() => {
                          setKeptLinkedTill(false);
                          getTillData();
                        }}
                      >
                        Choose a different till
                      </Button>
                      {" · "}
                      <a
                        href="/health"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: "/health", state: { from: "/till" } }); }}
                        style={{ fontWeight: 600, cursor: "pointer" }}
                      >
                        <MedicineBoxOutlined /> Run Diagnostics
                      </a>
                    </span>
                  }
                />
              )}

              {/* Error banner — visible even when tills are listed, so user knows something failed */}
              {tillLoadError && !loading && !(keptLinkedTill && !hasTillList) && (hasTillList || showLinkedTill) && (
                <Alert
                  type={retryCountRef.current >= MAX_RETRIES ? "error" : "warning"}
                  showIcon
                  closable
                  style={{ margin: "0 2em 1em 2em" }}
                  message={
                    tillLoadError === "sync_failed"
                      ? "Till sync failed — your session data may be outdated"
                      : tillLoadError === "no_till_data"
                      ? "Could not load till configuration from server"
                      : tillLoadError === "no_till_access"
                      ? "Server returned no till access — your user may not be assigned to a till on the backend"
                      : tillLoadError === "no_tills_found"
                      ? "Server returned no tills for this user"
                      : tillLoadError === "network"
                      ? "Network connection failed"
                      : tillLoadError === "api_error"
                      ? "Server returned an error"
                      : "An issue was detected"
                  }
                  description={
                    <span>
                      {retryCountRef.current >= MAX_RETRIES
                        ? "Multiple attempts failed. This is likely a backend configuration issue, not a network problem. "
                        : "You can still select a till below, but it may not work until this is resolved. "}
                      <a
                        href="/health"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: "/health", state: { from: "/till" } }); }}
                        style={{ fontWeight: 600, cursor: "pointer" }}
                      >
                        <MedicineBoxOutlined /> Run Diagnostics
                      </a>
                    </span>
                  }
                />
              )}

              {/* Resume Setup — registration exists but initial sync never completed */}
              {resumeSetupVisible && !loading && (
                <Alert
                  type="info"
                  showIcon
                  icon={<SyncOutlined />}
                  style={{ margin: "0 2em 1em 2em" }}
                  message="Till registered but initial sync incomplete"
                  description={
                    <span>
                      This till was previously registered but the initial data sync did not complete. Products, pricing, and sale types are missing.{" "}
                      <Button
                        type="link"
                        style={{ padding: 0, fontWeight: 600 }}
                        onClick={() => {
                          setResumeSetupVisible(false);
                          history.push("/login");
                        }}
                      >
                        Resume Setup →
                      </Button>
                    </span>
                  }
                />
              )}

              {/* Registration Progress */}
              {registrationStep >= 0 && loading && (
                <div style={{ margin: "0 2em 1.5em 2em", padding: "16px 20px", background: "#fff", borderRadius: 8, border: "1px solid #e8e8e8" }}>
                  <Typography.Text strong style={{ fontSize: 14, marginBottom: 12, display: "block" }}>Setting up till...</Typography.Text>
                  <Steps
                    size="small"
                    current={registrationStep}
                    status={registrationError ? "error" : "process"}
                    items={REGISTRATION_STEPS.map((title, i) => ({
                      title,
                      icon: i < registrationStep ? <CheckCircleOutlined style={{ color: "#52c41a" }} /> :
                            i === registrationStep && registrationError ? <CloseCircleOutlined style={{ color: "#ff4d4f" }} /> :
                            i === registrationStep ? <LoadingOutlined spin /> : undefined,
                    }))}
                  />
                </div>
              )}

              {/* Registration Error + Retry */}
              {registrationError && !loading && (
                <Alert
                  type="error"
                  showIcon
                  style={{ margin: "0 2em 1em 2em" }}
                  message={`Registration failed at step: ${REGISTRATION_STEPS[registrationError.step] || "Unknown"}`}
                  description={
                    <span>
                      {registrationError.message}{" "}
                      {lastRegistrationArgs && (
                        <Button
                          type="link"
                          style={{ padding: 0, fontWeight: 600 }}
                          onClick={() => {
                            setRegistrationError(null);
                            setRegistrationStep(-1);
                            const { search_key, csbUnitId, csUserId, cwrTillID, tillValue: pickedTillValue } = lastRegistrationArgs;
                            // BUG-2368: a failed sync put back the linked till's value; retry the pick.
                            if (pickedTillValue) useAuthStore.getState().setTillValue(pickedTillValue);
                            onRegistration(search_key, csbUnitId, csUserId, cwrTillID);
                          }}
                        >
                          Retry
                        </Button>
                      )}
                    </span>
                  }
                />
              )}

              {authHeaders?.access_token &&
                (authHeaders?.username || authHeaders?.email) &&
                tills?.map((e, index) => (
                  <div key={index} style={{ marginLeft: "2em", marginBottom: "1.5em" }}>
                    <p
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 600,
                        fontSize: "1vw",
                        paddingTop: "1.5em",
                        paddingLeft: "0.2em",
                        color: "#585768",
                        marginBottom: "0.5em",
                      }}
                    >
                      {Object.keys(e)[0]}
                    </p>

                    {/* 🔄 Responsive Flex Container */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "0.8rem",
                      }}
                    >
                      {e[Object.keys(e)[0]].map((res) => (
                        <Card
                          key={res.cwrTillID}
                          id="step1"
                          styles={{ body: { padding: "1vw", paddingBottom: 0 } }}
                          style={{
                            flex: "1 1 calc(20% - 1.5rem)",
                            minWidth: "10.5em",
                            maxWidth: "11em",
                            height: "8em",
                            borderRadius: "6px",
                            border: "1px solid #EEEEEF",
                            boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.04)",
                            backgroundColor: "#F3F4F9",
                            cursor: "pointer",
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                          }}
                          onClick={() => onSelectTill(res)}
                        >
                          <div style={{ flexGrow: 1 }}>
                            <div>
                              <Image preview={false} src={posImg} style={{ height: "1.5vw" }} />
                              <span style={{ marginLeft: "1em", color: "#0F0718" }}>{res.till}</span>
                            </div>
                          </div>

                          <div style={{ position: "absolute", bottom: 0, left: "1vw" }}>
                            <Image preview={false} src={res.status === "AVL" ? green : res.status === "INU" ? red : green} style={{ height: "0.9vw" }} />
                            <span
                              style={{
                                marginLeft: "5px",
                                fontSize: "1vw",
                                fontWeight: 600,
                                color: "#0F0718",
                              }}
                            >
                              {res.status === "AVL" ? "Available" : res.status === "INU" ? "In Use" : "Not Registered"}
                            </span>
                            <p
                              style={{
                                fontFamily: "Inter",
                                fontWeight: 600,
                                color: "#667085",
                                fontSize: "0.9vw",
                                marginBottom: "7px",
                              }}
                            >
                              {/* {res.userName} */}
                            </p>
                          </div>
                        </Card>
                      ))}
                    </div>
                  </div>
                ))}

              {/* ✅ Active Till (Same Responsive Layout) */}
              {showLinkedTill && (
                <div style={{ marginLeft: "2em", marginBottom: "2em" }}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.5rem",
                    }}
                  >
                    <Card
                      id="step1"
                      key={tillValue?.cwrTillID}
                      styles={{ body: { padding: "1vw" } }}
                      style={{
                        height: "7.5em",
                        width: "11em",
                        borderRadius: "6px",
                        border: "1px solid #EEEEEF",
                        boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.04)",
                        backgroundColor: "#F3F4F9",
                        cursor: "pointer",
                      }}
                      onClick={onTill}
                    >
                      <div>
                        <Image preview={false} src={posImg} style={{ height: "1.5vw" }} />
                        <span style={{ marginLeft: "1em", top: "15px" }}>{tillValue?.name}</span>
                      </div>
                      <div style={{ paddingTop: "1em" }}>
                        <span style={{ marginLeft: "5px", fontSize: "1vw", fontWeight: 600 }}></span>
                      </div>
                      <p
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 600,
                          marginLeft: "1.3em",
                          color: "#667085",
                          fontSize: "0.9vw",
                        }}
                      >
                        {tillValue?.userName}
                      </p>
                    </Card>
                  </div>
                </div>
              )}

              {!loading && !hasTillList && !showLinkedTill && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "2em",
                  }}
                >
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "50%",
                      backgroundColor: "#FFF3E0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "1.5em",
                    }}
                  >
                    <span style={{ fontSize: "28px" }}>!</span>
                  </div>
                  <p
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 600,
                      fontSize: "1.2rem",
                      color: "#0F0718",
                      marginBottom: "0.5em",
                    }}
                  >
                    {tillLoadError === "network"
                      ? "Unable to Connect"
                      : tillLoadError === "no_user"
                      ? "User Session Expired"
                      : tillLoadError === "no_tills_found"
                      ? "No Tills Available"
                      : tillLoadError === "sync_failed"
                      ? "Sync Failed"
                      : tillLoadError === "no_auth"
                      ? "Authentication Required"
                      : "No Tills Found"}
                  </p>
                  <p
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: "0.95rem",
                      color: "#667085",
                      maxWidth: "400px",
                      marginBottom: "1.5em",
                      lineHeight: 1.5,
                    }}
                  >
                    {tillLoadError === "network"
                      ? "Could not connect to the server. Please check your internet connection and try again."
                      : tillLoadError === "no_user"
                      ? "Your session could not be verified. Please log out and log in again."
                      : tillLoadError === "no_tills_found"
                      ? "No tills are configured for your account. Please contact your administrator to assign a CWR Till."
                      : tillLoadError === "sync_failed"
                      ? "Could not sync till data from the server. This may happen after a tenant switch or app update. Please try refreshing."
                      : tillLoadError === "no_till_access"
                      ? "The server returned null for till access (getTillAccess). This usually means your user is not assigned to a till on the backend, or the server's JDBC connection pool is exhausted. Contact your administrator."
                      : tillLoadError === "no_till_data"
                      ? "Till configuration returned empty from the server. The backend service may be down or misconfigured."
                      : tillLoadError === "no_auth"
                      ? "Authentication credentials are missing. Please log out and log in again."
                      : "No tills were found. Please try refreshing the page."}
                  </p>
                  {retryCountRef.current >= MAX_RETRIES && (
                    <p
                      style={{
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                        fontSize: "0.85rem",
                        color: "#ff4d4f",
                        maxWidth: "400px",
                        marginBottom: "1em",
                        lineHeight: 1.5,
                      }}
                    >
                      {retryCountRef.current} consecutive attempts have failed. This is likely a server-side issue — retrying will not help until the backend is fixed.
                    </p>
                  )}
                  <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", justifyContent: "center" }}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setTillLoadError(null);
                        setTills(undefined);
                        getTillData();
                      }}
                      style={{
                        height: "40px",
                        borderRadius: "8px",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                      }}
                    >
                      Retry
                    </Button>
                    <Button
                      icon={<MedicineBoxOutlined />}
                      onClick={() => history.push({ pathname: "/health", state: { from: "/till" } })}
                      style={{
                        height: "40px",
                        borderRadius: "8px",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                      }}
                    >
                      Run Diagnostics
                    </Button>
                    {(tillLoadError === "no_user" || tillLoadError === "no_auth") && (
                      <Button
                        onClick={() => onUserModal()}
                        style={{
                          height: "40px",
                          borderRadius: "8px",
                          fontFamily: "Inter, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Log Out
                      </Button>
                    )}
                  </div>
                </div>
              )}
            </Scrollbars>
          </Col>
          <Modal
            title="Stock Count Check Failed"
            open={errorModalVisible}
            onOk={() => setErrorModalVisible(false)}
            footer={[
              <Button key="ok" type="primary" onClick={() => setErrorModalVisible(false)}>
                OK
              </Button>,
            ]}
            onCancel={() => setErrorModalVisible(false)}
            centered
            width="70%"
          >
            <Table
              columns={[
                { title: "Item Name", dataIndex: "item_name", key: "item_name" },
                { title: "Item Code", dataIndex: "item_code", key: "item_code" },
              ]}
              dataSource={errorProducts}
              rowKey="item_code"
              pagination={false}
              size="small"
              scroll={{ x: "100%", y: "calc(100vh - 300px)" }}
            />
          </Modal>
          {/* TSK-5406: Logout confirmation. A past-day session offers only Close Till while it can close. */}
          <Modal
            title="Log out"
            open={!!logoutDialog}
            onCancel={() => setLogoutDialog(null)}
            centered
            footer={
              logoutDialog
                ? [
                    <Button key="cancel" data-testid="till-logout-cancel" onClick={() => setLogoutDialog(null)}>
                      Cancel
                    </Button>,
                    logoutDialog.canClose && logoutDialog.closePath ? (
                      <Button key="close" data-testid="till-logout-close-till" type="primary" onClick={onCloseTillFromLogout}>
                        Close Till
                      </Button>
                    ) : null,
                    logoutDialog.state === TILL_LOGOUT_STATE.OPEN_PAST_DAY && logoutDialog.canClose ? null : (
                      <Button key="logout" data-testid="till-logout-confirm" danger onClick={() => onUserModal(logoutDialog.narrowedTillData)}>
                        Logout
                      </Button>
                    ),
                  ]
                : null
            }
          >
            {logoutDialog && (
              <div data-testid="till-logout-dialog" data-state={logoutDialog.state}>
                <p style={{ marginBottom: logoutDialog.notes?.length ? "0.75rem" : 0 }}>
                  {logoutDialog.state === TILL_LOGOUT_STATE.OPEN_PAST_DAY
                    ? "The till session is still open from a previous business day. Close Till before logging out."
                    : logoutDialog.canClose && logoutDialog.closePath
                    ? "The till session on this device is still open. Close Till to end the day, or log out and sign in again later to continue the same session."
                    : "Do you want to log out?"}
                </p>
                {logoutDialog.notes?.length > 0 && (
                  <ul style={{ paddingLeft: "1.2rem", margin: 0 }}>
                    {logoutDialog.notes.map((note) => (
                      <li key={note}>{note}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </Modal>
        </Row>
      ) : (
        <Row></Row>
      )}
      <PostCloseSalesModal
        open={postCloseModalVisible}
        storeClosedDate={postCloseData.storeClosedDate}
        newBusinessDate={postCloseData.newBusinessDate}
        closedTime={postCloseData.closedTime}
        tillId={postCloseData.tillId}
        cashierName={postCloseData.cashierName}
        onContinue={handlePostCloseContinue}
        onCancel={handlePostCloseCancel}
      />
    </Spin>
  );
};
export default Till;
